// extracted by mini-css-extract-plugin
export default {"wrapperIcon":"PlanInfo_wrapperIcon__QAQNz"};